import React from 'react';

const Loader = ({ text = 'Loading' }) => (
  <div className="loader-overlay">
    <div className="loader-cosmic">
      <div className="loader-ring loader-ring-1"></div>
      <div className="loader-ring loader-ring-2"></div>
      <div className="loader-ring loader-ring-3"></div>
      <div className="loader-core"></div>
      {text && <div className="loader-text">{text}</div>}
    </div>
  </div>
);

export default Loader;
